import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";

export default function SubmitOpportunityPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    const params = searchParams.toString();
    navigate(params ? `/register?${params}` : "/register", { replace: true });
  }, [navigate, searchParams]);

  return null;
}
